<template>
  <main>
    <app-navbar v-if="showHeader" />
    <toast />
    <Product-modal />

    <div class="view-wrapper" v-if="showHeader">
      <b-container fluid="lg">
        <router-view />
      </b-container>
      <MobileNavbar v-if="detectMobile()" />
    </div>

    <router-view v-else />
  </main>
</template>

<script>
import AppNavbar from "@/components/header/Navbar";
import Toast from "@/components/toast/Toast";
import ProductModal from "@/components/capsule/ProductModal";
import MobileNavbar from "@/components/footer/MobileNavbar";
import MiscUtils from "@/utils/MiscUtils";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AppNavbar,
    ProductModal,
    Toast,
    MobileNavbar
  },

  created() {
    this.detectMobile = MiscUtils.detectMobile;
  },

  mounted() {
    this.checkAuthenticated();
  },

  computed: {
    ...mapGetters(["showHeader"])
  },

  methods: {
    ...mapActions(["checkAuthenticated"])
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "src/assets/stylesheets/bootstrap_overrides.scss";
@import "~vue-select/src/scss/vue-select.scss";
@import "~@/assets/fonts/flaticon/_flaticon.scss";
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600");
@import url("https://fonts.googleapis.com/css?family=Quicksand:300");
* {
  min-height: 0;
  min-width: 0;
}

html,
body {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  width: 100%;
  height: auto;
  margin: 0;
  scroll-behavior: smooth;
  overflow-x: hidden;
}

.view-wrapper {
  margin-top: 50px;
}

*:focus {
  outline: none;
}

.page-title {
  font-family: "Quicksand", sans-serif;
  font-weight: 300 !important;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue